import { render, staticRenderFns } from "./selfAccountAdd.vue?vue&type=template&id=56bcff4a&scoped=true&"
import script from "./selfAccountAdd.vue?vue&type=script&lang=js&"
export * from "./selfAccountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcff4a",
  null
  
)

export default component.exports